import '../sass/single-video-content.scss';

(() => {
    const $singleVideoContentTemplateParts = document.querySelectorAll('.single-video-content');

    $singleVideoContentTemplateParts.forEach($singleVideoContentTemplatePart => {
        const $videoPlayer = $singleVideoContentTemplatePart.querySelector('.single-video-content__video-player');

        const initVideoPlayer = () => {
            if (!$videoPlayer) return;

            new Plyr($videoPlayer);
        };

        initVideoPlayer();
    });
})();
